import FontSize from "./font-size"

const {build} = require('../../../../app/web/version')
import GrayPalette from "./gray-palette"
import {SkinColors} from "./colors/skin-colors";
import {DarkSkinColors} from "./colors/skins/dark-skin-colors";
import {LightSkinColors} from "./colors/skins/light-skin-colors";
// import {SkinColors} from "./colors/colors"

export enum SkinTheme {
    LIGHT   = 'light',
    DARK    = 'dark'
}

export enum SkinThemeOptions {
    LIGHT   = 'light',
    DARK    = 'dark',
    AUTO    = 'auto'
}

const debug = false
// const debug = "Skin manager"

export default class Skin {

    public currentSkin      : SkinTheme = SkinTheme.LIGHT  // light | dark // css file skin
    public loadedFiles      : any[]     = []

    public grayPalette      : GrayPalette | null    = null
    public fontSize         : FontSize | null    = null

    public colors           : SkinColors

    constructor(defaultTheme: string = 'auto') {

        const mode = _.get(gd, 'user.settings.skin.theme', defaultTheme)
        debug && console.log("user.settings.skin.theme = ", _.get(gd, 'user.settings.skin.theme'))
        debug && console.log("mode = ", mode)

        switch (mode) {

            case 'light' :
                debug && console.log("switch light")
                this.currentSkin = SkinTheme.LIGHT
                break

            case 'dark' :
                debug && console.log("switch dark")
                this.currentSkin = SkinTheme.DARK
                break

            case 'auto' :
            default     :
                debug && console.log("switch auto/default")

                if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                    debug && console.log("Using system preference and set to dark")
                    this.currentSkin = SkinTheme.DARK
                }
                break
        }

        debug && console.log("currenSkin = ", this.currentSkin)

        // this.loadedFiles = [];

        this.init();


        switch (this.currentSkin) {
            case SkinTheme.DARK :
                this.colors = new DarkSkinColors(this)
                break

            case SkinTheme.LIGHT:
            default             :
                this.colors    = new LightSkinColors(this)
        }


    }

    // required for shared view and others support
    // SkinManager should be created and available before init to use its methods (like loadDeferred)
    init() {

        // Experimental - add skin class to body
        // const layoutContainer = document.getElementById("ui-layout-container")
        const layoutContainer = document.body
        layoutContainer.classList.add('skin-'+this.currentSkin)
        // end set body class

        // Init gray palette (contrast)
        // gd may not be initialized yet - why how ?
        // @ts-ignore
        const lightPalette  = _.get(window.gd, 'user.settings.skin.lightPalette', null);
        // @ts-ignore
        const darkPalette  = _.get(window.gd, 'user.settings.skin.darkPalette', null);

        if (this.currentSkin === SkinTheme.DARK) {
            this.grayPalette    = new GrayPalette(darkPalette)
        } else {
            this.grayPalette    = new GrayPalette(lightPalette)
        }

        // Init font size
        // @ts-ignore
        const fontSize      = _.get(window.gd, 'user.settings.skin.fontSize', null);
        this.fontSize       = fontSize ? new FontSize(fontSize) : null;

        // init theme
    }

    get isLight() {
        return this.currentSkin === SkinTheme.LIGHT
    }

    get isDark() {
        return this.currentSkin === SkinTheme.DARK
    }


    getLogoPath() {
        return "/app/web/skin/"+this.currentSkin+"/img/logo.png?"+build;
    }

    getIconPath(iconName:string) {
        return "/app/web/skin/"+this.currentSkin+"/img/icons/"+iconName+"?"+build;
    }

    loadDeferred(appName:string,cssFileName:string) {
        return this.load2018(appName, cssFileName);
    }

    load2018(appName:string,cssFileName:string) {

        let isFound = false;

        _.forEach(this.loadedFiles, obj=>{
            if (obj.appName === appName && obj.cssFileName === cssFileName) {
                isFound = true;
            }
        });

        if (isFound) return true;


        this.loadedFiles.push({
            appName: appName,
            cssFileName: cssFileName
        });

        const fileName = gdConfig.assetsPath + "/skin/"+this.currentSkin+"/"+appName+"/"+cssFileName+".css";
        return gd.loader.css.loader2018(fileName);
    }

}
